import { motion } from "framer-motion";
import { BRAND } from "../../data/content";
import { Container, CTAButton, SectionLabel, scrollToHash, EASE } from "./ui";

const FinalCTA = () => (
  <section className="flex min-h-[92vh] items-center border-t border-line bg-ink" data-testid="final-cta">
    <Container className="py-28 text-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.97 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, amount: 0.35 }}
        transition={{ duration: 0.8, ease: EASE }}
      >
        <SectionLabel className="justify-center">InVogue Private & Corporate Concierge</SectionLabel>

        <h2 className="mx-auto mt-10 font-serif font-medium leading-[0.92] text-ivory text-[clamp(52px,8vw,130px)]">
          VOUS AVEZ
          <br />
          <span className="text-champagne">UNE DEMANDE ?</span>
        </h2>

        <p className="mx-auto mt-9 max-w-[520px] font-sans text-[15px] font-light leading-[1.8] text-neutral-400 md:text-base">
          Décrivez-nous simplement ce dont vous avez besoin.
          <br />
          Nous nous chargeons du reste.
        </p>

        <div className="mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <CTAButton onClick={() => scrollToHash("#demande")} testid="final-cta-primary">
            Confier une demande
          </CTAButton>
          <CTAButton variant="secondary" href={`tel:${BRAND.phoneTel}`} testid="final-cta-phone">
            {BRAND.phone}
          </CTAButton>
        </div>

        <p className="mt-12 font-display text-[10px] font-medium tracking-[0.18em] text-muted">
          CLIENTS PRIVÉS · DIRIGEANTS · ENTREPRISES
        </p>
      </motion.div>
    </Container>
  </section>
);

export default FinalCTA;
